module.exports = __webpack_public_path__ + "img/ios-attach.2e1a09b4.svg";